export default __webpack_public_path__ + "static/media/grandmaAndLadyM.469ba881.jpg";